type ScheduleTabId = 'permanent' | 'intervals' | 'schedule';

interface IScheduleFormValue {
  permanent?: boolean;
  interval?: string;
  timeFrames?: unknown[];
}

export type { ScheduleTabId };

export const deriveInitialScheduleTab = (
  schedule: IScheduleFormValue | undefined,
  showIntervals: boolean
): ScheduleTabId => {
  if (showIntervals && schedule?.interval) return 'intervals';
  if (schedule?.permanent === false) return 'schedule';
  return 'permanent';
};
